// extracted by mini-css-extract-plugin
module.exports = {"title":"depositsLinksList_title__2iroC"};